import { setAllPets } from '../utils/initialize';
import {
  SET_ALL_PETS,
} from '../constants';

const initialState = setAllPets();

const allPets = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_PETS:
      return [
        ...action.payload.allPets,
      ];
    default:
      return state;
  }
};

export default allPets;



// WEBPACK FOOTER //
// ./src/reducers/allPets.js